/// <reference types="@angular/localize" />


import { AppModule } from './app/app.module';
import { enablePatches } from 'immer';
import { platformBrowser } from "@angular/platform-browser";

enablePatches(); //enable patch support required for history

platformBrowser()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
